<template>
  <div class="mine-page">
    <div class="header">
      <UserCard
        :role="USER_ROLES.STORE_MANAGER"
        :user="user"
        :store="currentStore"
      />
    </div>
    <div>
      <CCell title="店铺名称" :value="user?.storeName" />
      <CCell title="切换为销售" is-link @click="onSwitch" />
    </div>
    <CConfirm ref="refCConfirm" />
  </div>
</template>

<script>
import CCell from "@/components/common/CCell.vue";
import CConfirm from "@/components/common/CConfirm.vue";
import UserCard from "@/components/common/UserCard.vue";
import { USER_ROLES } from "@/consts";
import normalPage from "@/mixins/normal-page";
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  mixins: [normalPage],
  components: { UserCard, CCell, CConfirm },
  data() {
    return {
      USER_ROLES,
    };
  },
  computed: {
    ...mapState(["account", "user"]),
    ...mapGetters(["currentStore"]),
  },
  watch: {
    "account.role": {
      deep: true,
      handler(role) {
        if (role === USER_ROLES.CLIENT_AGENT) {
          this.$router.replace({ name: "SAMy" });
        } else if (role === USER_ROLES.REGION_MANAGER) {
          this.$router.replace({ name: "AreaManagerMy" });
        }
      },
    },
  },
  methods: {
    ...mapActions(["switchSMRole"]),
    async onSwitch() {
      try {
        await this.$refs.refCConfirm.show("确定切换用户身份吗？");
        await this.switchSMRole(USER_ROLES.CLIENT_AGENT);
      } catch (error) {
        console.log("cancel switch");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.mine-page {
  width: 100vw;
  height: 100%;
  background-color: #fff;
}

.header {
  width: 100vw;
  height: 328/20rem;
}
</style>
